<template>
  <div class="notices">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">中央选调 - 资讯</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">刷新</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">新增</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">详情</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.noticeList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="title" label="标题" show-overflow-tooltip>
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.title }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="hasShow" label="是否展示" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text>{{ scope.row.hasShow ? '是' : '否' }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="100" show-overflow-tooltip />
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const loading = reactive({
  find: false,
})
const data = reactive({
  noticeList: [],
})

const show = reactive({
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.type = 'ZYXDS'
}
resetSearchParam()

const commitFindList = () => {
  api.get('/backend/notice/getNoticeList', { params: searchParam }).then(res => {
    data.noticeList = res.list
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'zyxds_notice', null)
  router.push('/zyxds_notice')
}

const del = () => {
  const notices = tabRef.value.getSelectionRows()
  const noticeIdList = notices.map(notice => notice.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的项？',
    autofocus: false,
    confirmButtonText: '删除',
    cancelButtonText: '取消',
  }).then(() => {
    api.post('/backend/notice/delNotice', { ids: noticeIdList }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    })
  })
}

const update = (row) => {
  const notice = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'zyxds_notice', notice)
  router.push('/zyxds_notice')
}
</script>

<style lang="less"></style>